//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {

    data: () => ({
        info: '',
        invoiceLocation: ''
    }),
    methods: {
        //发票详情
        getInfo() {
            this.$get('/pay/invoice?id=' + this.$route.query.id, '', function (res) {
                if (res.code == 200) {
                    this.info = res.data
                    this.invoiceLocation = res.data.invoiceLocation
                }
            })
        }
    },
    mounted() {
        if(!this.$route.query.id){
            this.$router.go(-1)
        }
        this.getInfo()
    }
}
